module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-privacy-policy.json
// module id = 497
// module chunks = 113077330405585